<template>
  <div>
    <div v-show="!showPage" style="height: 100vh"></div>
    <div v-show="showPage" v-html="landingHtml" class="external-html"></div>
  </div>
</template>

<script>
import landingHtml from '@/assets/html/230913-webflow.html'

import Lenis from '@studio-freight/lenis'
import gsap from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

import { mapMutations } from 'vuex'

export default {
  data() {
    return {
      landingHtml,
      showPage: false,
    }
  },
  created() {
    this.setHeadless(true)
    this.setFootless(true)
  },
  methods: {
    ...mapMutations('ui', ['setFootless']),
    ...mapMutations('ui/header', ['setHeadless']),
  },
  async mounted() {
    // 페이지 보여주기 잠시 지연
    await setTimeout((_) => {
      this.showPage = true
    }, 500)

    // 스크롤 부드럽게
    const lenis = new Lenis({
      duration: 3,
      easing: (t) => Math.min(1, 1.003 - Math.pow(2, -10 * t)),
      direction: 'vertical',
      gestureDirection: 'vertical',
      smooth: true,
      mouseMultiplier: 1,
      smoothTouch: false,
      touchMultiplier: 2,
      infinite: false,
    })
    function raf(time) {
      lenis.raf(time)
      requestAnimationFrame(raf)
    }
    requestAnimationFrame(raf)

    // 스크롤 애니메이션
    setTimeout((_) => {
      gsap.registerPlugin(ScrollTrigger)
      // 페이지 페이드인
      gsap.from('.page-wrapper', {
        opacity: 0,
        duration: 1,
      })

      // 상단 카드 및 셀러 이미지
      gsap.to('.reel-pay-card', {
        scrollTrigger: {
          trigger: '.customer-satisfaction-illustration',
          scrub: 3,
          start: '20% center',
        },
        rotateZ: -10,
      })
      gsap.to('.avatar-circle', {
        scrollTrigger: {
          trigger: '.customer-satisfaction-illustration',
          scrub: 3,
          start: '20% center',
        },
        y: -100,
      })

      // sticky reels 이미지들
      gsap.to('.is-image1', {
        opacity: 0,
        ease: 'none',
        scrollTrigger: {
          trigger: '.reel-c-2',
          start: 'top center',
          end: '-30% 0',
          scrub: true,
        },
      })
      gsap.to('.is-image2', {
        opacity: 1,
        ease: 'none',
        scrollTrigger: {
          trigger: '.reel-c-2',
          start: '-50% top',
          end: '10% -20%',
          scrub: true,
        },
      })
      gsap.to('.is-image2', {
        opacity: 0,
        ease: 'none',
        scrollTrigger: {
          trigger: '.reel-c-3',
          start: 'top top',
          end: '-30% 0',
          scrub: true,
        },
      })
      gsap.to('.is-image3', {
        opacity: 1,
        ease: 'none',
        scrollTrigger: {
          trigger: '.reel-c-3',
          start: '-50% top',
          end: '30% 0',
          scrub: true,
        },
      })

      // 네비게이션 클릭
      const navBtn = document.getElementById('nav-menu-btn')
      navBtn.addEventListener('click', (e) => {
        const menu = document.getElementById('w-nav-overlay-0')
        const isOpen = menu.getAttribute('data-open') === 'true'
        menu.setAttribute('data-open', !isOpen)
      })
    }, 500)
  },
}
</script>

<style lang="scss" scoped>
::v-deep {
  .main-wrapper {
    transition: all 0.5s ease-out !important;
  }

  .page-wrapper {
    background-color: #f1f1f8;
  }

  .navbar_container {
    box-shadow: 1px 1px 0.1875rem rgba(31, 31, 48, 0.07);

    .w-nav-link {
      color: $gray-100;
    }
  }

  .w-nav-overlay {
    opacity: 0;
    width: 100%;
    height: 300px;

    -webkit-animation-name: rollIn;
    animation-name: rollIn;
    -webkit-animation-duration: 0.3s;
    animation-duration: 0.3s;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both;
  }

  .w-nav-overlay[data-open='true'] {
    display: block;
    opacity: 1;
  }

  // 화면 커지면 사라지게
  @media screen and (min-width: 992px) {
    .w-nav-overlay[data-open='true'] {
      display: none;
    }
  }

  @-webkit-keyframes rollIn {
    0% {
      opacity: 0;
      -webkit-transform: translateY(-100%);
    }

    100% {
      opacity: 1;
      -webkit-transform: translateY(0px);
    }
  }

  @keyframes rollIn {
    0% {
      opacity: 0;
      -webkit-transform: translateY(-100%);
    }

    100% {
      opacity: 1;
      -webkit-transform: translateY(0px);
    }
  }

  p.text-size-medium {
    font-size: 18px !important;
    margin-bottom: 0;
  }

  .why-reel-pay_desktop-image-wrapper img {
    opacity: 0;
  }

  .faq_question {
    cursor: auto;
  }

  .faq_answer p {
    color: white;
    font-size: 16px !important;
    margin-bottom: 0;
  }
}
</style>
